// Exact match: similar campaigns exist (card recovery, unfinished-application
// remarketing) and must not be treated as recovery sessions.
// Keep in sync with the release condition on the A/B test flag in PostHog.
export const RECOVERY_CAMPAIGN =
  'hs_em_nl_nl_none_ln_nlc_tran_unfinished-app-b1';

const extractCampaignFromUrl = (href: string): string | null =>
  new URL(href).searchParams.get('utm_campaign');

/**
 * Whether the session started from the recovery email sent to applicants who
 * dropped off. Falls back to the current URL because the landingUrl snapshot
 * is written in an effect, after the loan application's first render.
 */
export const isRecoverySession = (): boolean => {
  try {
    const landingUrl =
      sessionStorage.getItem('landingUrl') ?? window.location.href;
    const campaign = extractCampaignFromUrl(landingUrl);
    return campaign === RECOVERY_CAMPAIGN;
  } catch {
    // No sessionStorage (private mode) or a malformed landingUrl
    return false;
  }
};
